(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExpensesFormController', PhysicalFairExpensesFormController);
    PhysicalFairExpensesFormController.$inject = ['$filter', '$stateParams', '$state', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];
    function PhysicalFairExpensesFormController($filter, $stateParams, $state, ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;

        vm.title                 = "New Expense";
        vm.expoSelected          = [];
        vm.cities                = [];
        vm.expenses;
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.citySelected          = [];
        vm.total;
        vm.submit                = submit;
        vm.formErrors            = [];
        vm.getExpense            = getExpense;
        vm.expense;        

        activate();

        function activate() {
            vm.selectExpo();             
        }

        function getExpense (id) {
            PhysicalFairService.getExpense(id).then(function(response){
                vm.expense = response.data;
            
                vm.expoSelected = $filter('filter')(vm.expo, {id: vm.expense.expo_id})[0];
                
                vm.selectCitiesByExpo(); 
                
                vm.total = vm.expense.total;
            }).catch(function(err) {
            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expo = response.data;

                if ($stateParams.hasOwnProperty('id')) {                         
                    vm.getExpense($stateParams.id);       
                    vm.title  = "Update Expense";         
                }
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.citySelected = [];
            
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;

                if (vm.expense) {
                    vm.citySelected = $filter('filter')(vm.cities, {expos_locations_id: vm.expense.expo_location_id})[0];
                }
            }).catch(function(err) {
            });
        }

        function submit() {            

            var fields = {
                expo_id             : vm.expoSelected.id,
                expo_location_id    : vm.citySelected.expos_locations_id,
                total               : vm.total                
            };     

            if ($stateParams.hasOwnProperty('id')) {  
                PhysicalFairService.updateExpense($stateParams.id, fields)
                    .then(function(response) {
                        if (response.errors) {
                            vm.formErrors = response.errors;   

                            var focusKey = Object.keys(vm.formErrors)[0];
                            vm.focusMe = { [focusKey]: true };      
                        } else {
                            $state.go("root.physicalfairs.expenses");
                        }   
                })
                .catch(function(err) {
                    alertify.notify('Sorry, an error occurred!', 'error', 5);
                    console.log(err);
                });
            } else {
                PhysicalFairService.storeExpense(fields)
                    .then(function(response) {
                        if (response.errors) {
                            vm.formErrors = response.errors;   

                            var focusKey = Object.keys(vm.formErrors)[0];
                            vm.focusMe = { [focusKey]: true };      
                        } else {
                            $state.go("root.physicalfairs.expenses");
                        }   
                })
                .catch(function(err) {
                    alertify.notify('Sorry, an error occurred!', 'error', 5);
                    console.log(err);
                });   
            }    
   
        }        
                
    }
})();